import gql from 'graphql-tag'
import { BuildingTypeFragment } from '@api/fragments'
import { IBuildingTypeWithCompany } from '@api/types'
import client from '@stores/apollo'

export default function details(id: string) {
  return client.gql
    .query({ query, variables: { id } })
    .then(({ data: { node: building } }: { data: { node: IBuildingTypeWithCompany } }) => building)
}

const query = gql`
  query buildingTypeDetails($id: ID!) {
    node(id: $id) {
      ... on BuildingType {
        ...BuildingTypeFragment
        company {
          id
        }
      }
    }
  }
  ${BuildingTypeFragment}
`
